import type { Model } from '@studio/models/device';
import type { T_Maybe } from '@tryiris-ai/js-types';
import { DriverStatus } from '../types.js';
import { fidelityLabelToString } from '#~/api/device/registry/utils.js';

const statusMap: Record<string, DriverStatus> = {
  Beta: DriverStatus.BETA
};

/**
 * Hook to get driver status for a specific model.
 *
 * @param modelId - The model ID to get status for
 * @returns The driver status or undefined if not found
 */
export const useDriverStatus = (model: T_Maybe<Model>): T_Maybe<DriverStatus> => {
  if (!model) {
    return undefined;
  }

  return statusMap[fidelityLabelToString(model.fidelity)] ?? undefined;
};
